import React from "react";
import styled from "@emotion/styled";
import { keyframes } from "@emotion/react";
import { twitterHandle } from "../consts/socials.constants";

import FacebookIcon from "@ecologi/assets/icons/social-icons/facebook.svg";
import TwitterIcon from "@ecologi/assets/icons/social-icons/twitter.svg";
import LinkedInIcon from "@ecologi/assets/icons/social-icons/linkedin.svg";

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const SocialShareWrapper = styled.div`
  display: none;
  position: fixed;
  right: 0;
  top: 260px;
  background-color: #fff;
  padding: 8px;
  border-bottom: 2px solid ${(props) => props.theme.colors.darkCream};
  animation: ${fadeIn} 2s ease forwards;
  z-index: 1;

  @media ${(props) => props.theme.bp.tabletUp} {
    display: block;
  }
`;

const SocialLink = styled.a`
  display: block;
  margin-bottom: 8px;

  &:last-child {
    margin-bottom: 0;
  }

  &:hover {
    opacity: 0.8;
  }
`;

export type Props = {
  shareLink: string;
  twitterShareText: string;
};

export const SocialShare = (props: Props) => {
  const { shareLink, twitterShareText } = props;

  return (
    <SocialShareWrapper>
      <SocialLink
        aria-label="share this page on Facebook"
        href={`https://www.facebook.com/sharer/sharer.php?u=${shareLink}`}
        rel="noopener noreferrer"
        target="_blank"
        title="Share this page on Facebook"
      >
        <FacebookIcon width={30} height={30} />
      </SocialLink>
      <SocialLink
        aria-label="share this page on Twitter"
        href={`https://twitter.com/intent/tweet?url=${shareLink}&via=${twitterHandle}&text=${twitterShareText}:`}
        rel="noopener noreferrer"
        target="_blank"
        title="Share this page on Twitter"
      >
        <TwitterIcon width={30} height={30} />
      </SocialLink>
      <SocialLink
        aria-label="share this page on LinkedIn"
        href={`https://linkedin.com/shareArticle?url=${shareLink}`}
        rel="noopener noreferrer"
        target="_blank"
        title="Share this page on LinkedIn"
      >
        <LinkedInIcon width={30} height={30} />
      </SocialLink>
    </SocialShareWrapper>
  );
};
